import styled, { css } from 'styled-components';
import { UploadListType } from 'antd/lib/upload/interface';
import { colors } from '@10d/tend-ui-tokens/samolet';

import { GalleryBulk } from 'ui/components/Icon';

import { Size } from '../FileIcon';

export const defaultStyles = css`
  font-family: var(--main-font);
  color: ${colors.gray900};
  background: ${colors.gray0};
  border: none;

  p {
    margin: 0;
    padding: 0;
    font-family: inherit;
  }

  button.ant-btn {
    display: flex;
    align-items: center;
    align-self: center;
    padding: 0;
  }
`;

export const Wrapper = styled.div<{ listType?: UploadListType }>`
  ${defaultStyles};
  box-shadow:
    0 8px 22px -6px #18274b0a,
    0px 14px 64px -4px #18274b0a;

  display: grid;
  grid-template-columns: 24px minmax(100px, 1fr) min-content;
  height: 40px;
  gap: 8px;
  padding: 0 12px;
  margin-top: 8px;
  border-radius: 12px;

  ${({ listType }) =>
    listType !== 'text' &&
    css`
      grid-template-columns: 32px minmax(100px, 1fr) min-content;
      height: 56px;
    `}

  .ant-progress {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ant-progress-show-info .ant-progress-outer {
    margin-right: 0;
    padding-right: 0;
  }

  .ant-progress-text {
    display: none;
  }
`;

export const FileName = styled.p`
  color: ${colors.blue600};
  cursor: pointer;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const NotFoundImage = styled(GalleryBulk)<{ size: Size }>`
  font-size: ${({ size }) => (size === Size.Small ? 24 : 32)}px;
  align-self: center;
  color: ${colors.gray400};
`;

export const FileImage = styled.img<{ size?: Size }>`
  align-self: center;
  justify-self: center;
  border-radius: 8px;
  object-fit: cover;
  width: 30px;
  height: 30px;
  cursor: pointer;

  ${({ size }) =>
    size === Size.Small &&
    css`
      width: 16px;
      height: 16px;
      border-radius: 4px;
    `}
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 12px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  line-height: 20px;
`;

export const FileProgress = styled.span`
  color: #bdc5db;
  font-family: inherit;
  font-weight: bold;
  line-height: 16px;
`;

export const FileSize = styled.p`
  flex-grow: 1;
  color: ${colors.gray400};
`;

export const FileError = styled.p`
  color: ${colors.red600};
`;

export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Footer = styled.div`
  display: flex;
  line-height: 20px;
`;
